export enum Ferramenta {
  CRESCER = 1,
  REGISTRO_FORMACAO = 2,
  AGENDAMENTO = 3,
}

export enum ModalidadeParticipante {
  Online = 'ONLINE',
  Presencial = 'PRESENCIAL',
  Hibrido = 'HIBRIDO',
}

export enum Rotas {
  presenca = 'presenca',
  agradecimento = 'agradecimento',
  agradecimentoNaoAssociado = 'agradecimento-nao-associado',
  encerrado = 'encerrado',
  crescerNaPratica = 'crescer-na-pratica',
  naoAutorizado = 'sem-autorizacao',
  naoEncontrado = 'nao-encontrado',
  nossoNegocioCooperativista = 'nosso-negocio-cooperativista',
}

export enum RotasComBarra {
  presenca = '/presenca',
  agradecimento = '/agradecimento',
  agradecimentoNaoAssociado = '/agradecimento-nao-associado',
  encerrado = '/encerrado',
  crescerNaPratica = '/crescer-na-pratica',
  naoAutorizado = '/sem-autorizacao',
  naoEncontrado = '/nao-encontrado',
}

export enum ApiErrorCode {
  RECAPTCHA_V3_ERROR = 1001,
  RECAPTCHA_V2_ERROR = 1002,
}
